<script>
  import { createEventDispatcher } from 'svelte';
  import { loadingStore } from '../../stores/General';
  import classNames from '../../utils/classNames';

  export let isUpdate = false;
  export let contentContainerClass = undefined;
  import { validationStore } from '../../stores/General';
  import GenericButton from '../button/GenericButton.svelte';
  const { isValid, isChanged, errors } = validationStore;
  const dispatch = createEventDispatcher();

  function handleCancel() {
    dispatch('cancel');
  }
</script>

<div
  class={classNames(
    contentContainerClass ??
      // TODO: the outrageous z-index is because the VideoPlayer has a ridiclously high z-index
      'bg-gray-200 bottom-0 fixed flex flex-row gap-4 justify-end p-4 right-3 w-full z-[100]'
  )}
>
  <GenericButton
    submit="true"
    disabled={!$isChanged || !$isValid || $loadingStore.loading}
    text={isUpdate ? 'Save' : 'Create'}
    loading={$loadingStore.loading}
    width="8rem"
  />
  <GenericButton disabled={$loadingStore.loading} onClick={handleCancel} width="8rem" buttonTheme="outline-default" text="Cancel" />
</div>
